module.exports = __webpack_public_path__ + "static/media/download-banner-placeholder.229edcc7.png";